<script setup>
defineProps({
    locale: {
        type: String,
        default: 'en',
    },
})
</script>

<template>
    <div
        class="bs-nav__menu-footer__social-bar"
    >
        <div class="bs-nav__menu-footer__social-bar__box">
            <a
                :href="'https://www.facebook.com/erfbibleserver' + (locale !== 'de' ? 'english' : '')"
                tabindex="-1"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
            >
                <v-icon>
                    bs:$vuetify.icons.mdiFacebook
                </v-icon>
            </a>
            <a
                href="https://www.instagram.com/erf_bibleserver"
                tabindex="-1"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
            >
                <v-icon>
                    bs:$vuetify.icons.mdiInstagram
                </v-icon>
            </a>
            <a
                href="https://www.erf.de"
                target="_blank"
                rel="noopener noreferrer"
                tabindex="-1"
                title="ERF Medien e.V."
            >
                &copy; {{ new Date().getFullYear() }} ERF
            </a>
        </div>
    </div>
</template>

<style lang="scss">
.bs-app .bs-nav {
    &__menu-footer {
        &__social-bar {
            display: flex;
            align-self: flex-end;
            justify-content: flex-end;
            width: 100%;
            margin-top: 20px;

            @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
                justify-content: flex-start;
            }

            &__box {
                position: relative;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                width: 100%;
                max-width: 60px;

                @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
                    justify-content: flex-start;
                    max-width: 200px;
                }

                a {
                    color: #fff;
                    font-size: 10px;
                    text-align: center;
                    text-decoration: none;

                    @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
                        margin-right: 12px;
                        text-align: left;
                    }

                    &:hover, &:focus {
                        text-decoration: underline;
                        outline: none;
                    }

                    svg {
                        color: #fff;
                    }

                    &:focus {
                        svg {
                            color: var(--bs-color-highlight);
                        }
                    }

                    &:last-child {
                        position: absolute;
                        bottom: 12px;
                        left: 50%;
                        width: 100px;
                        transform: translate(-50%, calc(100% + 32px));

                        @media (max-width: #{map-deep-get($bs-xs, breakpointValue)}px) {
                            position: absolute;
                            bottom: -8px;
                            left: 0 !important;
                            width: 100px;
                            transform: translate(0%, 100%) !important;
                        }
                    }
                }
            }
        }
    }
}
</style>
